import { render } from "./VUEComponenteGraficoCampioniRilevati.vue?vue&type=template&id=243874f5"
import script from "./VUEComponenteGraficoCampioniRilevati.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoCampioniRilevati.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__